import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { retry } from 'rxjs/internal/operators/retry';
import { throwError } from 'rxjs/internal/observable/throwError';

@Injectable({
  providedIn: 'root',
})
export class TaxService {
  public apiUrl = environment.API_URL;
  private http: HttpClient = inject(HttpClient);
  constructor() {}

  getTax(): Observable<any> {
    return this.http
      .get(`${this.apiUrl}${environment.VAT_TAX_LIST}`)
      .pipe(retry(1), catchError((error) => this.errorHandler(error)));
  }

  updateTax(
    id: any,
    payload: {
      tax_slug?: string,
      rate: number,
      rate_type?: string,
      conditional_rates?: Array<{
        _id?: string;
        hotel_star_min: number;
        hotel_star_max: number;
        rate: number;
      }>
    }
  ): Observable<any> {
    return this.http
      .put(`${this.apiUrl}${environment.UPDATE_VAT_TAX}/${id}`, payload)
      .pipe(retry(1), catchError((error) => this.errorHandler(error)));
  }
  addTax(
    payload: {
      rate: number,
      rate_type: string,
      conditional_rates?: Array<{
        _id?: string;
        hotel_star_min: number;
        hotel_star_max: number;
        rate: number;
      }>
    }
  ): Observable<any> {
    return this.http
      .post(`${this.apiUrl}${environment.ADD_VAT_TAX}`, payload)
      .pipe(retry(1), catchError((error) => this.errorHandler(error)));
  }

  private errorHandler(error: any): Observable<never> {
 return throwError(() => error);
  }
}
